"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// index.ts
var index_exports = {};
__export(index_exports, {
  BtnText: () => BtnText,
  CURRENCY: () => CURRENCY,
  CouponApplyOrRemoveStatus: () => CouponApplyOrRemoveStatus,
  EActivitiesWalkTypes: () => EActivitiesWalkTypes,
  EBUDDIES_STATUS: () => EBUDDIES_STATUS,
  EButtonType: () => EButtonType,
  ECategories: () => ECategories,
  EDefaultPayloadData: () => EDefaultPayloadData,
  EEVENT_INVITATION_CRITERIA: () => EEVENT_INVITATION_CRITERIA,
  EEventStatus: () => EEventStatus,
  EEventType: () => EEventType,
  EFRIENDTYPES: () => EFRIENDTYPES,
  EFeatureFlags: () => EFeatureFlags,
  EGENDERS: () => EGENDERS,
  EGUEST_HOST_ASSIGNMENTS: () => EGUEST_HOST_ASSIGNMENTS,
  EIcons: () => EIcons,
  EMessageStatus: () => EMessageStatus,
  EPLUS_ONE_BEHAVIOUR: () => EPLUS_ONE_BEHAVIOUR,
  EPlatform: () => EPlatform,
  EStatusType: () => EStatusType,
  ETankStackKeys: () => ETankStackKeys,
  EUSER_FEEDBACK_STATUSES: () => EUSER_FEEDBACK_STATUSES,
  EUSER_FEEDBACK_SUB_STATUSES: () => EUSER_FEEDBACK_SUB_STATUSES,
  EVENT_CLASS: () => EVENT_CLASS,
  EVENT_STATUS: () => EVENT_STATUS,
  EVENT_TICKET_TYPE: () => EVENT_TICKET_TYPE,
  EViewType: () => EViewType,
  EditWhoCanJoin: () => EditWhoCanJoin,
  Errors: () => Errors,
  EventFunctionMap: () => EventFunctionMap,
  EventStatusType: () => EventStatusType,
  FREE_TICKET_PRICE: () => FREE_TICKET_PRICE,
  FormType: () => FormType,
  MAX_TICKET_PRICE: () => MAX_TICKET_PRICE,
  MIN_TICKET_PRICE: () => MIN_TICKET_PRICE,
  PAYMENT_TYPE: () => PAYMENT_TYPE,
  QUESTIONNAIRES_TYPE: () => QUESTIONNAIRES_TYPE,
  TDisplayFormat: () => TDisplayFormat,
  TopHeading: () => TopHeading,
  eventJoinType: () => eventJoinType,
  interestsData: () => interestsData,
  letsHangSupportEmail: () => letsHangSupportEmail,
  ticketedCreateStackScreens: () => ticketedCreateStackScreens
});
module.exports = __toCommonJS(index_exports);

// Enums/index.ts
var EGENDERS = /* @__PURE__ */ ((EGENDERS2) => {
  EGENDERS2["RATHER_NOT_SAY"] = "rather-not-to-say";
  EGENDERS2["MALE"] = "male";
  EGENDERS2["FEMALE"] = "female";
  EGENDERS2["NON_BINARY"] = "non-binary";
  EGENDERS2["OPEN"] = "open";
  return EGENDERS2;
})(EGENDERS || {});
var EActivitiesWalkTypes = /* @__PURE__ */ ((EActivitiesWalkTypes2) => {
  EActivitiesWalkTypes2["REGULAR"] = "regular";
  EActivitiesWalkTypes2["INVALID"] = "invalid";
  EActivitiesWalkTypes2["FOF"] = "friends-of-friends-open";
  EActivitiesWalkTypes2["FOF_EXLCUISVE"] = "only-friends-of-friends";
  EActivitiesWalkTypes2["GROUP_OF"] = "group-of-friends";
  EActivitiesWalkTypes2["GROUP_FOF"] = "group-walk-with-friend-of-friends";
  EActivitiesWalkTypes2["GROUP_BOUNCE"] = "group-bounce-on-accepted";
  return EActivitiesWalkTypes2;
})(EActivitiesWalkTypes || {});
var EFRIENDTYPES = /* @__PURE__ */ ((EFRIENDTYPES2) => {
  EFRIENDTYPES2["FRIEND"] = "friend";
  EFRIENDTYPES2["FOF"] = "friend-of-a-friend";
  EFRIENDTYPES2["FRIENDS_THROUGH_A_FRIEND"] = "friend-through-a-friend";
  return EFRIENDTYPES2;
})(EFRIENDTYPES || {});
var EBUDDIES_STATUS = /* @__PURE__ */ ((EBUDDIES_STATUS2) => {
  EBUDDIES_STATUS2["ACCEPTED"] = "accepted";
  EBUDDIES_STATUS2["DENIED"] = "denied";
  EBUDDIES_STATUS2["NEW"] = "new";
  EBUDDIES_STATUS2["BLANK"] = "";
  EBUDDIES_STATUS2["EITHER"] = "either";
  EBUDDIES_STATUS2["SENT"] = "sent";
  return EBUDDIES_STATUS2;
})(EBUDDIES_STATUS || {});
var EUSER_FEEDBACK_SUB_STATUSES = /* @__PURE__ */ ((EUSER_FEEDBACK_SUB_STATUSES2) => {
  EUSER_FEEDBACK_SUB_STATUSES2["GREAT"] = "Great";
  EUSER_FEEDBACK_SUB_STATUSES2["OK"] = "OK";
  EUSER_FEEDBACK_SUB_STATUSES2["BAD"] = "BAD";
  EUSER_FEEDBACK_SUB_STATUSES2["DID_NOT_ATTEND"] = "Did not attend!";
  EUSER_FEEDBACK_SUB_STATUSES2["ACTIVITY_CANCELLED"] = "Activity Cancelled";
  EUSER_FEEDBACK_SUB_STATUSES2["TIP_DEVELOPER"] = "TipDeveloper";
  return EUSER_FEEDBACK_SUB_STATUSES2;
})(EUSER_FEEDBACK_SUB_STATUSES || {});
var EUSER_FEEDBACK_STATUSES = /* @__PURE__ */ ((EUSER_FEEDBACK_STATUSES2) => {
  EUSER_FEEDBACK_STATUSES2["PROVIDED"] = "feedback_provided";
  EUSER_FEEDBACK_STATUSES2["DECLINED"] = "feedback_declined";
  return EUSER_FEEDBACK_STATUSES2;
})(EUSER_FEEDBACK_STATUSES || {});
var EPLUS_ONE_BEHAVIOUR = /* @__PURE__ */ ((EPLUS_ONE_BEHAVIOUR2) => {
  EPLUS_ONE_BEHAVIOUR2["HARD_REQUIREMENT"] = "hard-requirement";
  EPLUS_ONE_BEHAVIOUR2["SOFT_REQUIREMENT"] = "soft-requirement";
  return EPLUS_ONE_BEHAVIOUR2;
})(EPLUS_ONE_BEHAVIOUR || {});
var EGUEST_HOST_ASSIGNMENTS = /* @__PURE__ */ ((EGUEST_HOST_ASSIGNMENTS2) => {
  EGUEST_HOST_ASSIGNMENTS2["HOST"] = "host";
  EGUEST_HOST_ASSIGNMENTS2["GUEST"] = "guest";
  EGUEST_HOST_ASSIGNMENTS2["NEITHER"] = "unmatched";
  return EGUEST_HOST_ASSIGNMENTS2;
})(EGUEST_HOST_ASSIGNMENTS || {});
var EEVENT_INVITATION_CRITERIA = /* @__PURE__ */ ((EEVENT_INVITATION_CRITERIA2) => {
  EEVENT_INVITATION_CRITERIA2["INVITE_BY_LINK_ONLY"] = "link_invite";
  EEVENT_INVITATION_CRITERIA2["PUBLIC"] = "public";
  EEVENT_INVITATION_CRITERIA2["BUDDIES"] = "buddies";
  EEVENT_INVITATION_CRITERIA2["BUDDIES_AND_FRIENDS"] = "buddies_and_friends";
  EEVENT_INVITATION_CRITERIA2["FRIENDS_OF_FRIENDS"] = "friends_of_friends";
  EEVENT_INVITATION_CRITERIA2["GROUPS"] = "groups";
  return EEVENT_INVITATION_CRITERIA2;
})(EEVENT_INVITATION_CRITERIA || {});
var EVENT_CLASS = /* @__PURE__ */ ((EVENT_CLASS2) => {
  EVENT_CLASS2["TICKETED_EVENT"] = "ticketed";
  EVENT_CLASS2["NON_TICKETED_EVENT"] = "non_ticketed";
  return EVENT_CLASS2;
})(EVENT_CLASS || {});
var EVENT_STATUS = /* @__PURE__ */ ((EVENT_STATUS2) => {
  EVENT_STATUS2["OPEN"] = "open";
  EVENT_STATUS2["CLOSE"] = "close";
  EVENT_STATUS2["DRAFT"] = "draft";
  return EVENT_STATUS2;
})(EVENT_STATUS || {});
var EVENT_TICKET_TYPE = /* @__PURE__ */ ((EVENT_TICKET_TYPE2) => {
  EVENT_TICKET_TYPE2["PAID_TICKET"] = "paid";
  EVENT_TICKET_TYPE2["CHIP_IN_TICKET"] = "chip_in";
  EVENT_TICKET_TYPE2["FREE_TICKET"] = "free_for_guests";
  return EVENT_TICKET_TYPE2;
})(EVENT_TICKET_TYPE || {});
var QUESTIONNAIRES_TYPE = /* @__PURE__ */ ((QUESTIONNAIRES_TYPE2) => {
  QUESTIONNAIRES_TYPE2["TEXT"] = "text";
  QUESTIONNAIRES_TYPE2["LONG_TEXT"] = "long_text";
  QUESTIONNAIRES_TYPE2["SINGLE_SELECT"] = "single_select";
  QUESTIONNAIRES_TYPE2["MULTI_SELECT"] = "multi_select";
  QUESTIONNAIRES_TYPE2["EMAIL"] = "email";
  QUESTIONNAIRES_TYPE2["DATE"] = "date";
  QUESTIONNAIRES_TYPE2["PHONE"] = "phone";
  QUESTIONNAIRES_TYPE2["ADDRESS"] = "address";
  QUESTIONNAIRES_TYPE2["NUMBER"] = "number";
  return QUESTIONNAIRES_TYPE2;
})(QUESTIONNAIRES_TYPE || {});
var PAYMENT_TYPE = /* @__PURE__ */ ((PAYMENT_TYPE2) => {
  PAYMENT_TYPE2["STRIPE"] = "stripe";
  PAYMENT_TYPE2["MANUAL"] = "manual";
  PAYMENT_TYPE2["FREE"] = "free";
  return PAYMENT_TYPE2;
})(PAYMENT_TYPE || {});
var EEventType = /* @__PURE__ */ ((EEventType2) => {
  EEventType2["FREE_INDIVIDUAL"] = "free-individual";
  return EEventType2;
})(EEventType || {});
var EventStatusType = /* @__PURE__ */ ((EventStatusType2) => {
  EventStatusType2["INVITED"] = "invited";
  EventStatusType2["ACCEPTED"] = "accepted";
  EventStatusType2["LEFT"] = "left";
  EventStatusType2["DECLINED"] = "declined";
  EventStatusType2["USER_DECLINED"] = "user_declined";
  EventStatusType2["INITIATOR"] = "initiator";
  EventStatusType2["NOT_INVITED"] = "not_invited";
  EventStatusType2["UNDER_REVIEW"] = "under_review";
  EventStatusType2["REFUND_REQUESTED"] = "refund_requested";
  EventStatusType2["REFUNDED"] = "refunded";
  EventStatusType2["ATTENDING"] = "attending";
  EventStatusType2["CHECKED_IN"] = "checked_in";
  EventStatusType2["CO_HOST"] = "co_host";
  EventStatusType2["OPENED_EXTERNAL_LINK"] = "opened_external_link";
  EventStatusType2["NOT_ATTENDING_EXTERNAL_EVENT"] = "not_attending_external_event";
  EventStatusType2["QUEUED"] = "queued";
  return EventStatusType2;
})(EventStatusType || {});
var CURRENCY = /* @__PURE__ */ ((CURRENCY2) => {
  CURRENCY2["USD"] = "USD";
  return CURRENCY2;
})(CURRENCY || {});
var EViewType = /* @__PURE__ */ ((EViewType2) => {
  EViewType2["BLUR"] = "blur";
  EViewType2["VIBRANCY"] = "vibrancy";
  return EViewType2;
})(EViewType || {});
var EPlatform = /* @__PURE__ */ ((EPlatform2) => {
  EPlatform2["WEB"] = "web";
  EPlatform2["IOS"] = "ios";
  EPlatform2["ANDROID"] = "android";
  return EPlatform2;
})(EPlatform || {});
var EFeatureFlags = /* @__PURE__ */ ((EFeatureFlags2) => {
  EFeatureFlags2["DEV_SETTINGS"] = "dev_settings";
  EFeatureFlags2["HANG_GENIE"] = "hang_genie";
  EFeatureFlags2["AI_INSIGHTS"] = "ai_insights";
  EFeatureFlags2["EXPLORE_SECTION"] = "explore_section";
  EFeatureFlags2["WHATSAPP_RSVP"] = "whatsapp_rsvp";
  EFeatureFlags2["PLUS_ONE"] = "plus_one";
  EFeatureFlags2["INCLUDE_EXTERNAL_EVENTS"] = "include_external_events";
  EFeatureFlags2["BUDDIES_SECTION"] = "buddies_section";
  EFeatureFlags2["ENABLE_ADD_PLUGIN_TO_EVENT"] = "enable_add_plugin_to_event";
  EFeatureFlags2["ENABLE_PLUGIN_CREATION"] = "enable_plugin_creation";
  EFeatureFlags2["TICKETED_EVENTS_WEB"] = "ticketed_events_web";
  EFeatureFlags2["VIDEO_PREVIEW"] = "video_preview";
  EFeatureFlags2["EDIT_EVENT"] = "edit_event_web";
  EFeatureFlags2["NEED_HELP_SUPPORT"] = "need_help_support";
  EFeatureFlags2["FLEXIBLE_EVENT_CREATION"] = "flexible_event_creation";
  EFeatureFlags2["GUEST_LIST_WEB_AWAITING"] = "guest_list_web_awaiting";
  EFeatureFlags2["GUEST_LIST_WEB_INVITED"] = "guest_list_web_invited";
  EFeatureFlags2["GUEST_LIST_WEB_GOING"] = "guest_list_web_going";
  EFeatureFlags2["GUEST_LIST_WEB_NOT_GOING"] = "guest_list_web_not_going";
  EFeatureFlags2["EMBEDDED_STRIPE_WEB"] = "embedded_stripe_web";
  return EFeatureFlags2;
})(EFeatureFlags || {});
var EMessageStatus = /* @__PURE__ */ ((EMessageStatus2) => {
  EMessageStatus2["INVITED"] = "Invited";
  EMessageStatus2["FAILED"] = "Failed";
  EMessageStatus2["SENDING"] = "Sending..";
  return EMessageStatus2;
})(EMessageStatus || {});
var ETankStackKeys = /* @__PURE__ */ ((ETankStackKeys2) => {
  ETankStackKeys2["EVENTS"] = "events";
  ETankStackKeys2["EVENT_DETAIL"] = "eventDetails";
  ETankStackKeys2["EVENT_MEMBER_LIST"] = "eventMemberList";
  ETankStackKeys2["GROUPS"] = "groups";
  ETankStackKeys2["GROUP_MEMBER_LIST"] = "groupMemberList";
  ETankStackKeys2["ACTIVITIES"] = "activities";
  ETankStackKeys2["EVENTS_ALL_TICKETS"] = "eventsAllTickets";
  ETankStackKeys2["PAID_EVENT_MEMBER_LIST"] = "paidEventMemberList";
  ETankStackKeys2["EVENT_PAYOUT"] = "eventPayout";
  ETankStackKeys2["EVENT_INSIGHT"] = "eventInsight";
  ETankStackKeys2["EVENT_AI_SUGGESTION"] = "eventAiSuggestion";
  ETankStackKeys2["EVENT_CAPACITY_PREDICTION"] = "EVENT_CAPACITY_PREDICTION";
  ETankStackKeys2["EVENT_CAMPAIGN_IDEAS"] = "EVENT_CAMPAIGN_IDEAS";
  ETankStackKeys2["EVENT_ACCEPTED_GUEST_AVATARS"] = "EVENT_ACCEPTED_GUEST_AVATARS";
  return ETankStackKeys2;
})(ETankStackKeys || {});
var BtnText = /* @__PURE__ */ ((BtnText2) => {
  BtnText2["Update"] = "Update";
  BtnText2["Next"] = "Next";
  BtnText2["Create"] = "Create";
  BtnText2["CreateEvent"] = "Create event";
  BtnText2["SaveDraft"] = "Save draft";
  return BtnText2;
})(BtnText || {});
var ticketedCreateStackScreens = /* @__PURE__ */ ((ticketedCreateStackScreens2) => {
  ticketedCreateStackScreens2["EventInfo"] = "EventInfo";
  ticketedCreateStackScreens2["EventLocation"] = "EventLocation";
  ticketedCreateStackScreens2["EventTiming"] = "EventTiming";
  ticketedCreateStackScreens2["EventJoinSettings"] = "EventJoinSettings";
  ticketedCreateStackScreens2["NewEvent"] = "New event";
  ticketedCreateStackScreens2["EditEvent"] = "Edit event";
  return ticketedCreateStackScreens2;
})(ticketedCreateStackScreens || {});
var TopHeading = {
  ["EventInfo" /* EventInfo */]: {
    title: "New event",
    subTitle: "Tell us what your event is about"
  },
  ["EventLocation" /* EventLocation */]: {
    title: "New event",
    subTitle: "Tell us your event's Location"
  },
  ["EventTiming" /* EventTiming */]: {
    title: "New event",
    subTitle: "Tell us your event's timing"
  },
  ["EventJoinSettings" /* EventJoinSettings */]: {
    title: "New event",
    subTitle: "Tell us who can join"
  },
  ["New event" /* NewEvent */]: {
    title: "New event",
    subTitle: "Tell us what your event is about"
  },
  ["Edit event" /* EditEvent */]: {
    title: "New event",
    subTitle: "Tell us what your event is about"
  }
};
var FormType = /* @__PURE__ */ ((FormType2) => {
  FormType2["draftId"] = "draftId";
  FormType2["eventName"] = "eventName";
  FormType2["eventDescription"] = "eventDescription";
  FormType2["addFlyer"] = "addFlyer";
  FormType2["flyerImage"] = "flyerImage";
  FormType2["scheduledDate"] = "scheduledDate";
  FormType2["scheduledEndDate"] = "scheduledEndDate";
  FormType2["eventStartTime"] = "eventStartTime";
  FormType2["eventEndTime"] = "eventEndTime";
  FormType2["eventSignUpCloseDate"] = "eventSignUpCloseDate";
  FormType2["eventSignUpCloseTime"] = "eventSignUpCloseTime";
  FormType2["whoCanJoin"] = "whoCanJoin";
  FormType2["minMaxPeople"] = "minMaxPeople";
  FormType2["minAge"] = "minAge";
  FormType2["maxAge"] = "maxAge";
  FormType2["gender"] = "gender";
  FormType2["eventLocation"] = "eventLocation";
  FormType2["locationDetails"] = "locationDetails";
  FormType2["guestLocationPreview"] = "guestLocationPreview";
  FormType2["requiredApproval"] = "requiredApproval";
  return FormType2;
})(FormType || {});
var Errors = {
  ["eventName" /* eventName */]: "Please fill out this field",
  ["eventDescription" /* eventDescription */]: "Please fill out this field",
  ["flyerImage" /* flyerImage */]: "FlyerImage is required when addFlyer is true",
  ["scheduledDate" /* scheduledDate */]: "Please fill out this field",
  ["scheduledEndDate" /* scheduledEndDate */]: "Please fill out this field",
  ["eventStartTime" /* eventStartTime */]: "Please fill out this field",
  ["eventEndTime" /* eventEndTime */]: "Please fill out this field",
  ["eventSignUpCloseDate" /* eventSignUpCloseDate */]: "Please fill out this field",
  ["eventSignUpCloseTime" /* eventSignUpCloseTime */]: "Please fill out this field",
  ["eventLocation" /* eventLocation */]: "Please fill out this field",
  ["locationDetails" /* locationDetails */]: "Enter location",
  ["whoCanJoin" /* whoCanJoin */]: "Enter whoCanJoin",
  ["minMaxPeople" /* minMaxPeople */]: "Enter minMaxPeople",
  ["minAge" /* minAge */]: "Please fill out this field",
  ["maxAge" /* maxAge */]: "Please fill out this field",
  ["gender" /* gender */]: "Enter gender",
  ["guestLocationPreview" /* guestLocationPreview */]: "Please fill out this field"
};
var eventJoinType = {
  ["public" /* PUBLIC */]: {
    title: "Anyone can join",
    label: "Anyone fitting the event criteria can join",
    icon: "anyOne",
    description: "Any gender can join",
    value: "link_invite" /* INVITE_BY_LINK_ONLY */
  },
  ["link_invite" /* INVITE_BY_LINK_ONLY */]: {
    title: "Anyone can join",
    label: "Anyone fitting the event criteria can join",
    icon: "anyOne",
    description: "Any gender can join",
    value: "link_invite" /* INVITE_BY_LINK_ONLY */
  },
  ["buddies" /* BUDDIES */]: {
    title: "Buddies",
    icon: "buddies",
    description: "Only Your friends can join",
    value: "buddies" /* BUDDIES */,
    label: "Only your buddies can join"
  },
  ["buddies_and_friends" /* BUDDIES_AND_FRIENDS */]: {
    title: "Buddies & friends",
    icon: "buddiesFriends",
    label: "Your buddies and their friends can join",
    description: "Your buddies and their friends can join",
    value: "buddies_and_friends" /* BUDDIES_AND_FRIENDS */
  },
  ["groups" /* GROUPS */]: {
    title: "Groups",
    icon: "groups",
    label: "Only the people in the group can join",
    description: "Only the people in the group can join",
    value: "groups" /* GROUPS */
  },
  ["friends_of_friends" /* FRIENDS_OF_FRIENDS */]: {
    title: "Friends of friends",
    icon: "friendsOfFriends",
    label: "Your friend's friends can join",
    description: "Your friend's friends can join",
    value: "friends_of_friends" /* FRIENDS_OF_FRIENDS */
  }
};
var EditWhoCanJoin = {
  link_invite: [eventJoinType.buddies, eventJoinType.buddies_and_friends],
  buddies: [eventJoinType.public, eventJoinType.buddies_and_friends],
  buddies_and_friends: [eventJoinType.public, eventJoinType.buddies]
};
var ECategories = {
  TICKET: "ticket",
  ADDON: "addon",
  SERVICE: "service",
  DONATION: "donation"
};
var TDisplayFormat = /* @__PURE__ */ ((TDisplayFormat2) => {
  TDisplayFormat2["ONE_PER_PAGE"] = "onePerPage";
  TDisplayFormat2["SINGLE_PAGE"] = "singlePage";
  return TDisplayFormat2;
})(TDisplayFormat || {});
var CouponApplyOrRemoveStatus = /* @__PURE__ */ ((CouponApplyOrRemoveStatus2) => {
  CouponApplyOrRemoveStatus2["APPLY"] = "apply";
  CouponApplyOrRemoveStatus2["REMOVE"] = "remove";
  return CouponApplyOrRemoveStatus2;
})(CouponApplyOrRemoveStatus || {});
var EEventStatus = /* @__PURE__ */ ((EEventStatus2) => {
  EEventStatus2["UPCOMING"] = "upcoming";
  EEventStatus2["CLOSED"] = "closed";
  EEventStatus2["INELIGIBLE"] = "ineligible";
  EEventStatus2["OVER"] = "over";
  EEventStatus2["CLOSE"] = "close";
  return EEventStatus2;
})(EEventStatus || {});
var EDefaultPayloadData = /* @__PURE__ */ ((EDefaultPayloadData2) => {
  EDefaultPayloadData2[EDefaultPayloadData2["MIN_AGE"] = 18] = "MIN_AGE";
  EDefaultPayloadData2[EDefaultPayloadData2["MAX_AGE"] = 100] = "MAX_AGE";
  EDefaultPayloadData2[EDefaultPayloadData2["MIN_PEOPLE"] = 0] = "MIN_PEOPLE";
  EDefaultPayloadData2[EDefaultPayloadData2["MAX_PEOPLE"] = 500] = "MAX_PEOPLE";
  return EDefaultPayloadData2;
})(EDefaultPayloadData || {});
var EStatusType = /* @__PURE__ */ ((EStatusType2) => {
  EStatusType2["Invited"] = "invited";
  EStatusType2["Accepted"] = "accepted";
  EStatusType2["Declined"] = "declined";
  EStatusType2["Open"] = "open";
  EStatusType2["Closed"] = "closed";
  EStatusType2["Canceled"] = "canceled";
  EStatusType2["Sent"] = "sent";
  EStatusType2["User_Declined"] = "user_declined";
  return EStatusType2;
})(EStatusType || {});

// index.ts
var EventFunctionMap = /* @__PURE__ */ ((EventFunctionMap2) => {
  EventFunctionMap2["NAVIGATE"] = "navigate";
  EventFunctionMap2["JOIN_EVENT"] = "joinEvent";
  EventFunctionMap2["JOIN_WAITLIST"] = "joinWaitlist";
  EventFunctionMap2["EXTERNAL_NAV"] = "externalNav";
  EventFunctionMap2["PLUS_ONES"] = "plusOnes";
  EventFunctionMap2["LEAVE_EVENT"] = "leaveEvent";
  EventFunctionMap2["SHARE"] = "share";
  EventFunctionMap2["EMPTY"] = "empty";
  return EventFunctionMap2;
})(EventFunctionMap || {});
var EIcons = /* @__PURE__ */ ((EIcons2) => {
  EIcons2["ticketOutlineIcon"] = "ticketOutlineIcon";
  EIcons2["shareEventIcon"] = "shareEventIcon";
  EIcons2["joinShareForwardIcon"] = "joinShareForwardIcon";
  EIcons2["joinExternalEventIcon"] = "JoinExternalEventIcon";
  return EIcons2;
})(EIcons || {});
var EButtonType = /* @__PURE__ */ ((EButtonType2) => {
  EButtonType2["outline"] = "outline";
  EButtonType2["solid"] = "solid";
  return EButtonType2;
})(EButtonType || {});
var MIN_TICKET_PRICE = 0.5;
var FREE_TICKET_PRICE = 0;
var MAX_TICKET_PRICE = 999999;
var interestsData = [
  "Comedy",
  "Music",
  "Concert",
  "Cricket",
  "Sports",
  "Birthday Bashes",
  "Books Celebration",
  "Swimming Event",
  "Hackathon",
  "Festival",
  "Street Events",
  "Girls Hangouts",
  "Hiking",
  "Travel Events",
  "Kids Playing Events",
  "Dating",
  "Groups",
  "Couples",
  "Afterparty",
  "Nightlife",
  "Party"
];
var letsHangSupportEmail = "letshang-support@vyral.info";
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  BtnText,
  CURRENCY,
  CouponApplyOrRemoveStatus,
  EActivitiesWalkTypes,
  EBUDDIES_STATUS,
  EButtonType,
  ECategories,
  EDefaultPayloadData,
  EEVENT_INVITATION_CRITERIA,
  EEventStatus,
  EEventType,
  EFRIENDTYPES,
  EFeatureFlags,
  EGENDERS,
  EGUEST_HOST_ASSIGNMENTS,
  EIcons,
  EMessageStatus,
  EPLUS_ONE_BEHAVIOUR,
  EPlatform,
  EStatusType,
  ETankStackKeys,
  EUSER_FEEDBACK_STATUSES,
  EUSER_FEEDBACK_SUB_STATUSES,
  EVENT_CLASS,
  EVENT_STATUS,
  EVENT_TICKET_TYPE,
  EViewType,
  EditWhoCanJoin,
  Errors,
  EventFunctionMap,
  EventStatusType,
  FREE_TICKET_PRICE,
  FormType,
  MAX_TICKET_PRICE,
  MIN_TICKET_PRICE,
  PAYMENT_TYPE,
  QUESTIONNAIRES_TYPE,
  TDisplayFormat,
  TopHeading,
  eventJoinType,
  interestsData,
  letsHangSupportEmail,
  ticketedCreateStackScreens
});
//# sourceMappingURL=index.js.map